import {
    MessageSquare,
    AlertCircle,
    FileText,
    Code,
    Shield,
    LogOut,
    HelpCircle,
    ShoppingBag,
    Ticket,
    Skull,
    Car,
    Zap,
    MessageSquareWarning,
    Link as LinkIcon
} from 'lucide-react';

export const FLOW_CONFIG = {
    // --- Ponto de Entrada ---
    'start': {
        id: 'start',
        question: 'Olá! Como podemos te ajudar hoje?',
        subtext: 'Selecione a opção que melhor descreve seu problema',
        type: 'choice',
        options: [
            { id: 'denuncia', label: 'Denunciar Jogador', icon: AlertCircle, desc: 'Reportar jogadores que violaram as regras da cidade (VDM, RDM, etc.)', colorClass: 'from-red-500/20 to-orange-500/20 text-red-400 group-hover:ring-red-500/50' },
            { id: 'compras', label: 'Problema com Compras', icon: ShoppingBag, desc: 'Ajuda com aprovação de compras, VIPs ou itens não recebidos', colorClass: 'from-emerald-500/20 to-green-500/20 text-emerald-400 group-hover:ring-emerald-500/50' },
            { id: 'tecnico', label: 'Problema Técnico / Bug', icon: Code, desc: 'Reportar bugs, falhas no sistema ou problemas de conexão', colorClass: 'from-blue-500/20 to-indigo-500/20 text-blue-400 group-hover:ring-blue-500/50' },
            { id: 'punicao', label: 'Revogar Punição', icon: Shield, desc: 'Solicitar revisão de banimentos ou advertências recebidas', colorClass: 'from-purple-500/20 to-pink-500/20 text-purple-400 group-hover:ring-purple-500/50' },
            { id: 'staff', label: 'Denúncia contra Staff', icon: AlertCircle, desc: 'Reportar comportamento inadequado ou abuso por parte da equipe', colorClass: 'from-orange-500/20 to-yellow-500/20 text-orange-400 group-hover:ring-orange-500/50' },
            { id: 'duvidas', label: 'Dúvidas Gerais', icon: HelpCircle, desc: 'Tirar dúvidas sobre o funcionamento da cidade ou regras', colorClass: 'from-cyan-500/20 to-sky-500/20 text-cyan-400 group-hover:ring-cyan-500/50' },
            { id: 'super_cupom', label: 'SUPER CUPOM', icon: Ticket, desc: 'Ganhe um acesso exclusivo e cupom de desconto limitado', colorClass: 'from-amber-500/20 to-yellow-500/20 text-amber-400 group-hover:ring-amber-500/50' },
            { id: 'cupons', label: 'Cupom ou Desconto', icon: Ticket, desc: 'Resolver problemas com ativação de códigos promocionais', colorClass: 'from-pink-500/20 to-rose-500/20 text-pink-400 group-hover:ring-pink-500/50' }
        ],
        next: (answer) => {
            const map = {
                'denuncia': 'city_select_denuncia',
                'compras': 'city_select_compras',
                'tecnico': 'city_select_tecnico',
                'punicao': 'city_select_punicao',
                'staff': 'city_select_staff',
                'duvidas': 'city_select_duvidas',
                'super_cupom': 'city_select_super_cupom',
                'cupons': 'city_select_cupons'
            };
            return map[answer] || 'start';
        }
    },

    // --- Seleção de Cidade (Reutilizável mas com próx passos diferentes) ---
    'city_select_denuncia': {
        id: 'city_select_denuncia',
        question: 'Em qual cidade ocorreu o incidente?',
        type: 'city_select',
        required: true,
        next: 'denuncia_player_id'
    },
    'city_select_compras': {
        id: 'city_select_compras',
        question: 'Para qual cidade foi a compra?',
        type: 'city_select',
        required: true,
        next: 'compras_transacao'
    },
    'city_select_tecnico': {
        id: 'city_select_tecnico',
        question: 'Em qual cidade você encontrou o problema?',
        type: 'city_select',
        required: true,
        next: 'tecnico_tipo'
    },
    'city_select_punicao': {
        id: 'city_select_punicao',
        question: 'Em qual cidade você foi punido?',
        type: 'city_select',
        required: true,
        next: 'punicao_id'
    },
    'city_select_super_cupom': {
        id: 'city_select_super_cupom',
        question: 'Para qual cidade você deseja o Cupom?',
        type: 'city_select',
        required: true,
        next: 'super_cupom_auto_create'
    },
    'super_cupom_auto_create': {
        id: 'super_cupom_auto_create',
        question: 'Processando seu pedido...',
        type: 'loading',
        categoryMap: 'super_cupom',
        description: 'Solicitação de Super Cupom Exclusivo',
        next: 'finish'
    },

    // --- Fluxo: Interceptação de Punição ---
    'punishment_selection_intercept': {
        id: 'punishment_selection_intercept',
        question: 'Selecione a Punição',
        subtext: 'Encontramos punições ativas neste personagem. Selecione qual deseja contestar.',
        type: 'punishment_list',
        required: true,
        next: 'punishment_appeal_form',
        categoryMap: 'contestar_punicao'
    },
    'punishment_appeal_form': {
        id: 'punishment_appeal_form',
        question: 'Formulário de Contestação',
        subtext: 'Preencha os dados da sua defesa',
        type: 'appeal_form',
        required: true,
        next: 'finish',
        categoryMap: 'contestar_punicao'
    },
    'city_select_staff': {
        id: 'city_select_staff',
        question: 'Em qual cidade ocorreu o incidente com o Staff?',
        type: 'city_select',
        required: true,
        next: 'staff_nome'
    },
    'city_select_duvidas': {
        id: 'city_select_duvidas',
        question: 'Sua dúvida é sobre qual cidade?',
        type: 'city_select',
        required: true,
        next: 'duvidas_desc'
    },
    'city_select_cupons': {
        id: 'city_select_cupons',
        question: 'Em qual cidade você tentou usar o cupom?',
        type: 'city_select',
        required: true,
        next: 'cupom_tipo'
    },
    'cupom_tipo': {
        id: 'cupom_tipo',
        question: 'Você já possui um código?',
        type: 'choice',
        resultKey: 'couponRequestType',
        options: [
            { id: 'tenho_codigo', label: 'Tenho um Código', icon: Ticket, desc: 'Tenho um cupom mas ele deu erro ou não funcionou' },
            { id: 'solicitar_cupom', label: 'Gostaria de Solicitar', icon: ShoppingBag, desc: 'Quero saber sobre cupons de criadores ou eventos' }
        ],
        required: true,
        next: (answer) => answer === 'tenho_codigo' ? 'cupom_codigo' : 'cupom_solicitacao_desc'
    },

    // --- Fluxo: Denúncia Jogador ---
    'denuncia_player_id': {
        id: 'denuncia_player_id',
        question: 'Qual o ID do jogador que você quer denunciar?',
        subtext: 'Insira apenas os números',
        type: 'number',
        placeholder: 'Ex: 12345',
        resultKey: 'reportedPlayerId',
        required: true,
        next: 'denuncia_regra'
    },
    'denuncia_regra': {
        id: 'denuncia_regra',
        question: 'Qual regra foi violada?',
        type: 'choice',
        resultKey: 'ruleViolated',
        options: [
            { id: 'rdm', label: 'RDM (Random Death Match)', icon: Skull, desc: 'Matar ou agredir outro jogador sem motivo aparente ou RP prévio.' },
            { id: 'vdm', label: 'VDM (Vehicle Death Match)', icon: Car, desc: 'Utilizar veículo como arma para atropelar ou matar sem justificativa.' },
            { id: 'metagaming', label: 'Metagaming', icon: Zap, desc: 'Utilizar informações externas (Discord, Lives) dentro do jogo.' },
            { id: 'powergaming', label: 'Powergaming', icon: Zap, desc: 'Realizar ações impossíveis na vida real ou abusar da física do jogo.' },
            { id: 'combat_log', label: 'Combat Logging', icon: LogOut, desc: 'Desconectar do jogo durante uma ação ou abordagem para evitar consequências.' },
            { id: 'ofensas', label: 'Ofensas / Toxicidade', icon: MessageSquareWarning, desc: 'Discurso de ódio, racismo, homofobia ou toxicidade excessiva.' },
            { id: 'ameaças', label: 'Ameaças OOC', icon: AlertCircle, desc: 'Ameaçar o jogador fora do ambiente de interpretação.' },
            { id: 'fear_rp', label: 'Fear RP', icon: Shield, desc: 'Não demonstrar medo pela vida em situações de risco (ex: ponta de arma).' },
            { id: 'amor_rp', label: 'Amor à Vida / RP', icon: HelpCircle, desc: 'Não valorizar a vida do personagem ou agir de forma surreal.' },
            { id: 'rameagem', label: 'Rameagem', icon: MessageSquare, desc: 'Uso indevido de canais de comunicação ou comportamentos disruptivos.' },
            { id: 'outros', label: 'Outros', icon: HelpCircle, desc: 'Outra violação não listada aqui.' }
        ],
        required: true,
        next: 'denuncia_evidencia'
    },
    'denuncia_evidencia': {
        id: 'denuncia_evidencia',
        question: 'Você tem provas?',
        subtext: '⚠️ Obrigatório: Envie vídeo upado no YouTube (Não Listado), Streamable ou Imgur. Prints podem não ser suficientes.',
        type: 'text',
        placeholder: 'https://youtube.com/...',
        resultKey: 'evidenceUrl',
        required: false,
        next: 'denuncia_desc'
    },
    'denuncia_desc': {
        id: 'denuncia_desc',
        question: 'Descreva o que aconteceu',
        subtext: 'Dê detalhes sobre o contexto da situação',
        type: 'textarea',
        resultKey: 'description',
        required: true,
        categoryMap: 'denuncia_jogador',
        next: 'upload_proofs'
    },

    // --- Fluxo: Compras ---
    'compras_transacao': {
        id: 'compras_transacao',
        question: 'Qual o ID da Transação?',
        subtext: 'Encontrado no comprovante de pagamento ou email',
        type: 'text',
        resultKey: 'transactionId',
        required: true,
        next: 'compras_email'
    },
    'compras_email': {
        id: 'compras_email',
        question: 'Qual email foi usado na compra?',
        type: 'email',
        resultKey: 'purchaseEmail',
        required: true,
        next: 'compras_desc'
    },
    'compras_desc': {
        id: 'compras_desc',
        question: 'Qual foi o problema?',
        subtext: 'Ex: Não recebi os diamantes, VIP não ativou...',
        type: 'textarea',
        resultKey: 'description',
        required: true,
        categoryMap: 'compras_doacoes',
        next: 'finish'
    },

    // --- Fluxo: Técnico / Bugs ---
    'tecnico_tipo': {
        id: 'tecnico_tipo',
        question: 'Onde está o problema?',
        type: 'choice',
        resultKey: 'bugType',
        options: [
            { id: 'bug_jogo', label: 'Dentro do Jogo' },
            { id: 'bug_site', label: 'No Site / Painel' },
            { id: 'bug_discord', label: 'No Discord' },
            { id: 'sugestao', label: 'É uma Sugestão' }
        ],
        required: true,
        next: 'tecnico_passos'
    },
    'tecnico_passos': {
        id: 'tecnico_passos',
        question: 'Como podemos reproduzir esse erro?',
        subtext: 'Passo a passo para que nossos devs vejam o problema',
        type: 'textarea',
        resultKey: 'stepsToReproduce',
        required: true,
        next: 'tecnico_esperado'
    },
    'tecnico_esperado': {
        id: 'tecnico_esperado',
        question: 'O que deveria acontecer?',
        type: 'textarea',
        resultKey: 'expectedBehavior', // Mapear para description se backend nao suportar, mas no plano diz novos campos
        required: false,
        next: 'tecnico_desc'
    },
    'tecnico_desc': {
        id: 'tecnico_desc',
        question: 'Algo mais a acrescentar?',
        subtext: 'Descrição adicional ou link de print/video',
        type: 'textarea',
        resultKey: 'description',
        required: true,
        categoryMap: 'programacao',
        next: 'upload_proofs'
    },

    // --- Fluxo: Punição ---
    'punicao_id': {
        id: 'punicao_id',
        question: 'ID da Punição (se houver)',
        type: 'text',
        resultKey: 'punishmentId',
        required: true,
        next: 'punicao_data'
    },
    'punicao_data': {
        id: 'punicao_data',
        question: 'Quando ocorreu a punição?',
        type: 'date',
        resultKey: 'punishmentDate',
        required: true,
        next: 'punicao_desc'
    },
    'punicao_desc': {
        id: 'punicao_desc',
        question: 'Por que a punição foi injusta?',
        subtext: 'Apresente sua defesa',
        type: 'textarea',
        resultKey: 'description',
        required: true,
        categoryMap: 'contestar_punicao',
        next: 'finish'
    },

    // --- Fluxo: Denúncia Staff ---
    'staff_nome': {
        id: 'staff_nome',
        question: 'Nome ou ID do Staff',
        type: 'text',
        resultKey: 'staffName', // Correct semantic key
        required: true,
        next: 'staff_evidencia'
    },
    'staff_evidencia': {
        id: 'staff_evidencia',
        question: 'Link da Prova (Obrigatório)',
        subtext: 'Denúncias contra staff exigem provas em vídeo/print',
        type: 'text',
        resultKey: 'evidenceUrl',
        required: true,
        next: 'staff_desc'
    },
    'staff_desc': {
        id: 'staff_desc',
        question: 'Descreva o comportamento inadequado',
        type: 'textarea',
        resultKey: 'description',
        required: true,
        categoryMap: 'denuncia_staff',
        next: 'upload_proofs'
    },

    // --- Fluxo: Dúvidas ---
    'duvidas_desc': {
        id: 'duvidas_desc',
        question: 'Qual sua dúvida?',
        type: 'textarea',
        resultKey: 'description',
        required: true,
        categoryMap: 'suporte_duvidas',
        next: 'finish'
    },

    // --- Fluxo: Cupons ---
    'cupom_codigo': {
        id: 'cupom_codigo',
        question: 'Qual o código do cupom?',
        type: 'text',
        resultKey: 'couponCode',
        required: true,
        next: 'cupom_desc'
    },
    'cupom_desc': {
        id: 'cupom_desc',
        question: 'O que houve com o cupom?',
        type: 'textarea',
        resultKey: 'description',
        required: true,
        categoryMap: 'cupons_descontos',
        next: 'finish'
    },
    'cupom_solicitacao_desc': {
        id: 'cupom_solicitacao_desc',
        question: 'Qual tipo de cupom você procura?',
        subtext: 'Ex: Vi em uma live, cupom de influencer, etc.',
        type: 'textarea',
        resultKey: 'description',
        required: true,
        categoryMap: 'cupons_descontos',
        next: 'finish'
    },

    // --- Passo de Upload ---
    'upload_proofs': {
        id: 'upload_proofs',
        question: 'Deseja anexar provas?',
        subtext: 'Envie prints ou vídeos da situação (Opcional)',
        type: 'upload',
        resultKey: 'attachedFiles',
        required: false,
        next: 'finish'
    }
};
